"use client";

import Link from "next/link";
import { useState } from "react";
import { CADENCE_PRICING, quarterlyOffers } from "@/lib/plans";
import { subscriptionMoney } from "@/lib/subscription-display";
import { QuarterlyOptions } from "./QuarterlyOptions";

export function QuarterlyPricingCard({ signedIn }: { signedIn: boolean }) {
  const [lbs, setLbs] = useState(120);
  const offer = quarterlyOffers().find(option => option.lbs === lbs)!;
  const destination = signedIn ? `/account?offer=${offer.id}&scroll=subscription` : `/signin?redirect=${offer.id}`;
  return (
    <article data-pricing-plan="quarter" data-animate data-delay="3" className="relative flex h-full min-w-0 flex-col rounded-2xl bg-[#243A6B] p-7 text-white ring-2 ring-[#F2B705] shadow-[0_26px_56px_rgba(31,27,46,0.24)]">
      <span className="absolute -top-3 left-7 inline-flex w-fit rounded-md bg-[#F2B705] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#2E2404]">Most popular with Bruins</span>
      <h4 className="text-base font-bold uppercase tracking-wide">Quarterly</h4>
      <div aria-live="polite" aria-atomic="true" className="mt-4">
        <div className="flex flex-wrap items-end gap-x-1.5 gap-y-2"><span className="text-[2.25rem] font-bold leading-none tabular-nums sm:text-[2.75rem]">{subscriptionMoney(offer.price_cents)}</span><span className="mb-1 text-sm">/quarter</span></div>
        <p className="mt-2 text-xs font-medium text-white/80">Billed every 3 months</p>
      </div>
      <QuarterlyOptions lbs={lbs} onChange={setLbs} dark />
      <div className="my-5 h-px bg-white/15" />
      <ul className="flex-1 space-y-2.5 text-sm leading-relaxed">
        <li><span className="font-semibold tabular-nums">{lbs} lbs</span> covered each quarter</li>
        <li>Pickup &amp; delivery included</li>
        <li>Unused lbs roll over (up to {lbs} lb)</li>
      </ul>
      <p className="mt-5 rounded-lg bg-black/10 px-3.5 py-2.5 text-xs leading-relaxed">Overage: {subscriptionMoney(CADENCE_PRICING.quarter.per_lb_rate_cents)}/lb after your available balance is used.</p>
      <Link href={destination} aria-label={`Continue with ${offer.id === "big-boy" ? offer.name : "Regular"}`} className="mt-5 block rounded-xl bg-[#F2B705] px-4 py-3 text-center text-sm font-semibold text-[#2E2404] hover:bg-[#F6C23D] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#F2B705]">Continue &rarr;</Link>
    </article>
  );
}
